// NOTE: This is a restriction from algolia.
// Only use alphanumeric, equal, plus, slash, hyphen, or underscore characters as prefix.
const uniqueIdGenerator = (prefix = '') => {
  try {
    return prefix + globalThis.crypto.randomUUID()
  } catch {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    let randomStr = Math.random().toString(36).substring(2, 11)

    // Fallback: Use timestamp if random padding failed to reach 9 characters

    /**
     * When Math.random() returns values approximately < 0.00028 (1/36²), the base-36 representation will have very few significant digits
     * The smaller the random value, the shorter the resulting string after substring(2, 11)
     * Eg: Math.random() = 0.0001 → toString(36) = "0.1s" → substring(2, 11) = "1s" (2 chars) ❌
     */
    if (randomStr.length < 9) {
      const timestampStr = Date.now().toString(36)
      // Take characters from timestamp to pad to 9 characters total
      const needed = 9 - randomStr.length
      randomStr += timestampStr.slice(-needed)
    }

    return `${prefix}_${randomStr}`
  }
}
export default uniqueIdGenerator
